import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';
import s from './FormInputField.module.scss';
import classNames from 'classnames';

const FormInputField = ({
    label,
    register,
    type,
    name,
    helptext,
    errors,
    errorMessage = 'This field is required',
}) => {
    const [isActive, setIsActive] = useState(false);
    const [isValid, setIsValid] = useState(null);

    const handleBlur = (e) => {
        const value = e.target.value;
        setIsActive(value.trim() !== '');

        if (type === 'email') {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            setIsValid(emailPattern.test(value));
        } else {
            setIsValid(value !== '');
        }
    };

    const fieldClasses = classNames(
        s.Field,
        { [s[`Field--IsActive`]]: isActive },
        { [s[`Field--Error`]]: errors && errors[name]?.type === 'required' }
    );

    return (
        <div className={s.Root}>
            <input
                id={name}
                type={type}
                name={name}
                {...register}
                onBlur={handleBlur}
                className={fieldClasses}
            />
            <label htmlFor={name} className={s.Label}>
                {label}
            </label>
            {helptext && <p className={s.HelpText}>{helptext}</p>}
            {errors && errors[name]?.type === 'required' && (
                <span className={s.ErrorMessage}>{errorMessage}</span>
            )}
        </div>
    );
};

FormInputField.propTypes = {
    placeholder: PropTypes.string,
    label: PropTypes.string.isRequired,
    register: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    errors: PropTypes.object,
    helptext: PropTypes.string,
    onChange: PropTypes.func,
};

export default FormInputField;
